/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Credit_DescriptionInputs */

const en_admin_settings_groups_credit_description = /** @type {(inputs: Admin_Settings_Groups_Credit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initial credits for new users`)
};

/**
* | output |
* | --- |
* | "Initial credits for new users" |
*
* @param {Admin_Settings_Groups_Credit_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_credit_description = /** @type {((inputs?: Admin_Settings_Groups_Credit_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Credit_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_credit_description(inputs)
});
export { admin_settings_groups_credit_description as "admin.settings.groups.credit.description" }